import { Typography } from '@mui/material';
import { SearchForm } from 'organisms/u009/SearchForm';
import { RecruitingAudition } from 'organisms/u009/RecruitingAudition';
import { AppFooter } from 'templates/AppFooter';
import { AppHeader } from 'templates/AppHeader';
import { useGetRecruitingAuditions } from 'hooks/u009/useGetRecruitingAuditionsHooks';
import { useRecruitingAuditionsSearch } from 'hooks/u009/useRecruitingAuditionsSearchHooks';
import { MediaQueryEnum, useMediaQuery } from 'commons/utils';
import { PageContent } from 'templates/PageContent';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { TransitionButton } from 'atoms/TransitionButton';
import { useContext, useState } from 'react';
import { FormContentHeader } from 'atoms/FormContentHeader';
import { AppContext } from 'templates/AppContextProvider';
import LoadingModal from 'organisms/LoadingModal';

export const RecruitingAuditions = () => {
  const isSp = useMediaQuery(MediaQueryEnum.sp);
  const { t: tRecruitingAuditions } = useTranslationWithLang('recruitingAuditions');
  const { filter, setKeyword } = useRecruitingAuditionsSearch();
  const { currentLang } = useContext(AppContext);
  const [data, loading, err] = useGetRecruitingAuditions(currentLang);

  const searchedData = data && filter(data.auditions);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setKeyword(e.currentTarget.keyword.value);
  };

  const RecrutingAuditionsResult = () => {
    if (err) {
      return (
        <Typography variant="body1" component="h2" className="text-[--c-error]">
          {tRecruitingAuditions('TU009_005')}
        </Typography>
      );
    }
    if (searchedData && searchedData.length > 0) {
      return (
        <>
          {searchedData.map((audition) => {
            return (
              <RecruitingAudition
                key={audition.id + audition.lang}
                {...audition}
                now={data.now_dtm}
                box={{
                  sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    my: 6,
                  },
                }}
              />
            );
          })}
        </>
      );
    }
    if (searchedData && searchedData.length === 0) {
      return (
        <Typography variant="body1" component="h2">
          {tRecruitingAuditions('TU009_006')}
        </Typography>
      );
    }
    return <></>;
  };

  const [searchValue, setSearchValue] = useState('');

  return (
    <>
      {loading && <LoadingModal />}
      <div style={{ background: 'var(--c-background)' }}>
        <AppHeader />
        <div role="heading" aria-level={1} aria-live="assertive" className="sr-only">
          {tRecruitingAuditions('TU009_008')}
        </div>
        <PageContent>
          <div className="w-full max-w-7xl mx-auto pt-10 px-5 text-[--c-text] bg-[--c-bg]">
            <FormContentHeader label={tRecruitingAuditions('TU009_008')} />
            <div className="max-w-[800px] mt-8 m-auto">
              <SearchForm
                searchValue={searchValue}
                onChange={setSearchValue}
                handleSubmit={handleSubmit}
              />
            </div>
            <div className={`${isSp ? 'p-2' : 'p-6'} max-w-[800px] m-auto`}>
              <RecrutingAuditionsResult />
            </div>
          </div>
          <div className="flex justify-center items-center">
            <TransitionButton className="w-[10rem]" />
          </div>
        </PageContent>
        <AppFooter />
      </div>
    </>
  );
};
